// // import React, { Fragment, 
// //   // useEffect,
// //    useState } from "react";
// // import { Link, useNavigate } from "react-router-dom";
// // import {
// //   Box,
// //   Container,
// //   Typography,
// //   Drawer,
// //   Button,
// //   List,
// //   ListItem,
// //   ListItemButton,
// //   ListItemText,
// //   Menu,
// //   MenuItem,
// // } from "@mui/material";
// // import { makeStyles } from "@mui/styles";
// // import Colors from "assets/Style/Colors";
// // import { FontFamily, Images } from "assets";
// // import { PrimaryButton } from "components/Buttons";
// // import { useAuth } from "context/UseContext";
// // import MenuIcon from "@mui/icons-material/Menu";
// // import CloseIcon from "@mui/icons-material/Close";


// // const useStyles = makeStyles({
// //   root: {
// //     position: "absolute",
// //     left: 0,
// //     top: 0,
// //   },
// // });

// // function Header() {
// //   const classes = useStyles();
// //   const navigate = useNavigate();
// //   const { user } = useAuth();
// //   const [permission, setPermission] = useState();
// //   const [drawer, setDrawer] = useState(false);

// //   const nav1 = [
// //     { title: "Home", path: "/" },
// //     { title: "Services", path: "/services" },
// //     { title: "About Us", path: "/about" },
// //     { title: "Quote", path: "/quote" },
// //     { title: "Careers", path: "/careers" },
// //     { title: "Blogs", path: "/blogs" },
// //     { title: "Contact Us", path: "/contact" },
// //     // { title: "Buy A Car", path: "/buycar" },
// //   ];

// //   const [openDrawer, setOpenDrawer] = useState(false);

// //   const [anchorEl, setAnchorEl] = useState(null);

// //   const [scrollEffect, setScrollEffect] = useState(false);

// //   const anchor = ["right"];

// //   const toggleDrawers = (anchor, open) => (event) => {
// //     setDrawer({ ...drawer, [anchor]: open });
// //     // setDrawer(!drawer);
// //     // setSearchDrawer(!searchDrawer)
// //   };

// //   const getPermission = () => {
// //     Notification.requestPermission().then((permission) => {
// //       if (permission === "granted") {
// //         console.log("Notification permission granted.");
// //         localStorage.setItem("Permission", true);
// //         setPermission(true);
// //       } else {
// //         localStorage.setItem("Permission", false);
// //         setPermission(false);
// //       }
// //     });
// //   };

// //   const handleClick = (event) => {
// //     if (anchorEl !== event.currentTarget) {
// //       setAnchorEl(event.currentTarget);
// //     }
// //   };

// //   const handleClose = () => {
// //     setAnchorEl(null);
// //   };

// //   // useEffect(() => {
// //   //   getPermission();
// //   // }, []);

// //   const handleScroll = () => {
// //     const scrollY = window.scrollY;

// //     if (scrollY > 1) {
// //       setScrollEffect(true);
// //     } else {
// //       setScrollEffect(false);
// //     }
// //   };

// //   window.addEventListener("scroll", handleScroll);
// //   const handleDrawerClose = (path) => {
// //     setOpenDrawer(false);
// //     setTimeout(() => {
// //       navigate(path);
// //     }, 1);
// //   };
// //   return (
// //     <Box
// //       className="header"
// //       sx={{ height: { xs: "55px", lg: "75px" }, 
// //     backgroundColor: Colors.white, 
// //     boxShadow: scrollEffect ? '0px 2px 10px rgba(0, 0, 0, 0.1)' : 'none', 
// //     transition: 'all 0.3s ease'
// //     }}
// //     >
// //       {/* ========== Header Top Bar ========== */}
// //       {/* <TopBar /> */}

// //       <Box
// //         sx={{ display: { xs: "none", sm: "none", md: "none", lg: "block" } }}
// //       >
// //         <Container maxWidth="xl">
// //           <Box
// //             sx={{
// //               display: { xs: "none", sm: "none", md: "none", lg: "flex" },
// //               alignItems: "center",
// //               justifyContent: "space-between",
// //             }}
// //           >
// //             <Box
// //               sx={{ display: "flex", alignItems: "center", mr: 0.5, gap: 3.5 }}
// //             >
// //               <Box sx={{ mr: 2 }}>
// //                 <Link to={"/"}>
// //                   <Box
// //                     component="img"
// //                     src={Images.newLogo}
// //                     alt="Galaxy World Wide Shipping"
// //                     height={70}
// //                   />
// //                 </Link>
// //               </Box>
// //               {nav1.map((item, index) => (
// //                 <Link key={index} to={item.path}>
// //                   <Typography
// //                     variant="body2"
// //                     sx={{
// //                       color: Colors.textSecondary,
// //                       fontFamily: FontFamily.Montserrat,
// //                       fontWeight: 600,
// //                       ":hover": { color: Colors.primary },
// //                     }}
// //                   >
// //                     {item.title}
// //                   </Typography>
// //                 </Link>
// //               ))}
// //             </Box>
// //             <Box sx={{ display: "flex", alignItems: "center", mr: 3, gap: 4 }}>
// //               <Box sx={{ display: "flex", gap: "10px" }}>
// //                 {user?.token ? (
// //                   <PrimaryButton
// //                     fullWidth
// //                     title={"Galaxy Business Suite"}
// //                     color={"primary"}
// //                     onClick={() => navigate("/dashboard")}
// //                   />
// //                 ) : (
// //                   <Fragment>
// //                     {/* <PrimaryButton
// //                       fullWidth
// //                       variant={'outlined'}
// //                       title={'Login'}
// //                       color={'primary'}
// //                       onClick={() => navigate('/login')}
// //                     /> */}
// //                     <PrimaryButton
// //                       fullWidth
// //                       title={"Galaxy Business Suite"}
// //                       color={"primary"}
// //                       // onClick={() => navigate('/register')}
// //                       aria-owns={anchorEl ? "simple-menu" : undefined}
// //                       aria-haspopup="true"
// //                       onClick={handleClick}
// //                       onMouseOver={handleClick}
// //                     />
// //                     <Menu
// //                       id="simple-menu"
// //                       anchorEl={anchorEl}
// //                       open={Boolean(anchorEl)}
// //                       onClose={handleClose}
// //                       MenuListProps={{ onMouseLeave: handleClose }}
// //                       transformOrigin={{ horizontal: "right", vertical: "top" }}
// //                       anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
// //                       PaperProps={{
// //                         elevation: 0,
// //                         sx: {
// //                           overflow: "visible",
// //                           filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
// //                           mt: 1.5,
// //                           ".MuiSvgIcon-root": {
// //                             width: 20,
// //                             height: 20,
// //                             ml: 0.5,
// //                             mr: 0.5,
// //                           },
// //                           "&:before": {
// //                             content: '""',
// //                             display: "block",
// //                             position: "absolute",
// //                             top: 0,
// //                             right: 14,
// //                             width: 10,
// //                             height: 10,
// //                             transform: "translateY(-50%) rotate(45deg)",
// //                             zIndex: 0,
// //                           },
// //                         },
// //                       }}
// //                     >
// //                       <MenuItem onClick={() => navigate("/register")}>
// //                         Customer Registration
// //                       </MenuItem>
// //                       <MenuItem onClick={() => window.open(`${process.env.REACT_APP_STAFF_BASE_URL}auth`, '_blank')}>
// //                         Employee Login
// //                       </MenuItem>
// //                       <MenuItem onClick={() => window.open(`${process.env.REACT_APP_CUSTOMER_BASE_URL}`, "_blank")}>
// //                         Customer Login
// //                       </MenuItem>
// //                     </Menu>
// //                   </Fragment>
// //                 )}
// //               </Box>
// //             </Box>
// //           </Box>
// //         </Container>
// //       </Box>
// //       <Container>
// //         <Box
// //           sx={{
// //             position: "sticky",
// //             top: 0,
// //             zIndex: 11,
// //             display: {
// //               xs: "flex",
// //               sm: "flex",
// //               md: "flex",
// //               lg: "none",
// //               justifyContent: "space-between",
// //             },
// //           }}
// //         >
// //           <Link to={"/"}>
// //             <Box
// //               component="img"
// //               src={Images.logoWhite}
// //               alt="Galaxy World Wide Shipping"
// //               height={60}
// //             />
// //           </Link>
// //           {anchor.map((anchor, index) => (
// //             <Fragment key={index}>
// //               <Button onClick={() => setOpenDrawer(true)}>
// //                 {index === 0 && <MenuIcon />}
// //               </Button>
// //               <Drawer
// //                 anchor={anchor}
// //                 open={openDrawer}
// //                 onClose={() => setOpenDrawer(false)}
// //                 PaperProps={{
// //                   style: {
// //                     width: "100%",
// //                   },
// //                 }}
// //               >
// //                 {anchor === "right" && (
// //                   <List>
// //                     <ListItem>
// //                       <ListItemButton
// //                         onClick={toggleDrawers(anchor, false)}
// //                         sx={{ justifyContent: "flex-end" }}
// //                       // onClick={() => setOpenDrawer(false)}
// //                       // sx={{ justifyContent: 'flex-end' }}
// //                       >
// //                         <CloseIcon />
// //                       </ListItemButton>
// //                     </ListItem>
// //                     <ListItem sx={{ justifyContent: "center" }}>
// //                       <Box
// //                         component="img"
// //                         src={Images.logo}
// //                         alt="Galaxy World Wide Shipping"
// //                         height={100}
// //                       />
// //                     </ListItem>
// //                     {nav1.map((item, index) => (
// //                       <ListItem key={index}>
// //                         <ListItemButton
// //                           onClick={() => handleDrawerClose(item.path)}
// //                         >
// //                           <ListItemText primary={item.title} />
// //                         </ListItemButton>
// //                       </ListItem>
// //                     ))}
// //                   </List>
// //                 )}
// //               </Drawer>
// //             </Fragment>
// //           ))}
// //         </Box>
// //       </Container>
// //     </Box>
// //   );
// // }

// // export default Header;


// import React, { Fragment, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import {
//   Box,
//   Container,
//   Typography,
//   Drawer,
//   Button,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemText,
//   Menu,
//   MenuItem,
// } from "@mui/material";
// import Colors from "assets/Style/Colors";
// import { FontFamily, Images } from "assets";
// // import { PrimaryButton } from "components/Buttons";
// import { useAuth } from "context/UseContext";
// import MenuIcon from "@mui/icons-material/Menu";
// import CloseIcon from "@mui/icons-material/Close";
// import { KeyboardArrowRight } from "@mui/icons-material";

// function Header() {
//   const navigate = useNavigate();
//   const { user } = useAuth();

//   const navItems = [
//     { title: "Home", path: "/" },
//     { title: "Services", path: "/services" },
//     { title: "About Us", path: "/about" },
//     { title: "Quote", path: "/quote" },
//     { title: "Careers", path: "/careers" },
//     { title: "Blogs", path: "/blogs" },
//     { title: "Contact Us", path: "/contact" },
//   ];

//   const [scrollEffect, setScrollEffect] = useState(false);
//   const [openDrawer, setOpenDrawer] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);

//     const handleScroll = () => {
//     const scrollY = window.scrollY;

//     if (scrollY > 1) {
//       setScrollEffect(true);
//     } else {
//       setScrollEffect(false);
//     }
//   };
//   window.addEventListener("scroll", handleScroll);

//   const handleDrawerClose = (path) => {
//     setOpenDrawer(false);
//     setTimeout(() => navigate(path), 1);
//   };

//   const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
//   const handleMenuClose = () => setAnchorEl(null);
// // const [permission, setPermission] = useState(null);

// //   const getPermission = () => {
// //     Notification.requestPermission().then((perm) => {
// //       if (perm === "granted") {
// //         localStorage.setItem("Permission", "true");
// //         setPermission(true);
// //       } else {
// //         localStorage.setItem("Permission", "false");
// //         setPermission(false);
// //       }
// //     });
// //   };

// //   useEffect(() => {
// //     getPermission();
// //   }, []);
//   return (
//    <Box
//   sx={{
//     position: "fixed",
//     left: 0,
//     top: 0,
//     width: "100%",
//     zIndex: 1200,
//     height: { xs: "55px", lg: "75px" },
//     backgroundColor: Colors.white,
//     px: 4,
//     boxShadow: scrollEffect
//       ? "0px 2px 10px rgba(0, 0, 0, 0.1)"
//       : "none",
//     transition: "all 0.3s ease",
//   }}
// >

//       {/* Desktop Header */}
//       <Box sx={{ display: { xs: "none", lg: "flex" }, alignItems: "center", height: "100%" }}>
//         <Container maxWidth="100%" >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//             }}
//           >
//             {/* Left: Logo */}
//             <Link to="/">
//               <Box
//                 component="img"
//                 src={Images.newLogo}
//                 alt="Galaxy World Wide Shipping"
//                 height={70}
//               />
//             </Link>

//             {/* Center: Nav Items */}
//             <Box sx={{ display: "flex", gap: 4, justifyContent: "center", flexGrow: 1 }}>
//               {navItems.map((item, index) => (
//                 <Link key={index} to={item.path}>
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: Colors.textSecondary,
//                       fontFamily: FontFamily.Montserrat,
//                       fontWeight: 600,
//                       ":hover": { color: Colors.landingPrimary },
//                     }}
//                   >
//                     {item.title}
//                   </Typography>
//                 </Link>
//               ))}
//             </Box>

// <Box>
//   {user?.token ? (
//     <Button
//       variant="contained"
//       sx={{
//         backgroundColor: Colors.landingPrimary,
//         color: Colors.white,
//         fontWeight: 600,
//         borderRadius:2,
//         py:1,
//         textTransform: "none",
//         ":hover": { backgroundColor: Colors.primaryDark || Colors.landingPrimary },
//       }}
//       onClick={() => navigate("/dashboard")}
//     >
//       Galaxy Business Suite
//     </Button>
//   ) : (
//     <Fragment>
//       <Button
//         variant="contained"
//         sx={{
//           backgroundColor: Colors.landingPrimary,
//           color: Colors.white,
//           fontWeight: 600,
//            borderRadius:2,
//         py:1,
//           textTransform: "none",
//           ":hover": { backgroundColor: Colors.primaryDark || Colors.landingPrimary },
//         }}
//         aria-owns={anchorEl ? "simple-menu" : undefined}
//         aria-haspopup="true"
//         onClick={handleMenuOpen}
//         endIcon= <KeyboardArrowRight sx={{ fontSize: { xs: 22, sm: 30 }, color: "#fff" }} />
//       >
//         Galaxy Business Suite
//       </Button>

//       <Menu
//         id="simple-menu"
//         anchorEl={anchorEl}
//         open={Boolean(anchorEl)}
//         onClose={handleMenuClose}
//         MenuListProps={{ onMouseLeave: handleMenuClose }}
//         transformOrigin={{ horizontal: "right", vertical: "top" }}
//         anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//         PaperProps={{
//           elevation: 0,
//           sx: {
//             overflow: "visible",
//             filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
//             mt: 1.5,
//             "&:before": {
//               content: '""',
//               display: "block",
//               position: "absolute",
//               top: 0,
//               right: 14,
//               width: 10,
//               height: 10,
//               transform: "translateY(-50%) rotate(45deg)",
//               zIndex: 0,
//             },
//           },
//         }}
//       >
//         <MenuItem onClick={() => navigate("/register")}>
//           Customer Registration
//         </MenuItem>
//         <MenuItem
//           onClick={() =>
//             window.open(
//               `${process.env.REACT_APP_STAFF_BASE_URL}auth`,
//               "_blank" , 'noopener,noreferrer'
//             )
//           }
//         >
//           Employee Login
//         </MenuItem>
//         <MenuItem
//           onClick={() =>
//             window.open(
//               `${process.env.REACT_APP_CUSTOMER_BASE_URL}`,
//               "_blank" , 'noopener,noreferrer'
//             )
//           }
//         >
//           Customer Login
//         </MenuItem>
//       </Menu>
//     </Fragment>
//   )}
// </Box>
//           </Box>
//         </Container>
//       </Box>

//       {/* Mobile Header */}
//       <Box sx={{ display: { xs: "flex", lg: "none" }, alignItems: "center", justifyContent: "space-between", px: 2 }}>
//         <Link to="/">
//           <Box
//             component="img"
//             src={Images.GalaxyLogo}
//             alt="Galaxy World Wide Shipping"
//             height={60}
//             width={250}
//           />
//         </Link>
//         <Button onClick={() => setOpenDrawer(true)}>
//           <MenuIcon />
//         </Button>
//         <Drawer
//           anchor="right"
//           open={openDrawer}
//           onClose={() => setOpenDrawer(false)}
//           PaperProps={{ style: { width: "100%" } }}
//         >
//           <List>
//             <ListItem sx={{ justifyContent: "flex-end" }}>
//               <ListItemButton onClick={() => setOpenDrawer(false)}>
//                 <CloseIcon />
//               </ListItemButton>
//             </ListItem>
//             <ListItem sx={{ justifyContent: "center" }}>
//               <Box component="img" src={Images.logo} alt="Logo" height={100} />
//             </ListItem>
//             {navItems.map((item, index) => (
//               <ListItem key={index}>
//                 <ListItemButton onClick={() => handleDrawerClose(item.path)}>
//                   <ListItemText primary={item.title} />
//                 </ListItemButton>
//               </ListItem>
//             ))}
//           </List>
//         </Drawer>
//       </Box>
//     </Box>
//   );
// }

// export default Header;

import React, { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Drawer,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  
  KeyboardArrowDown,
  KeyboardArrowRight,
} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import Colors from "assets/Style/Colors";
import { FontFamily, Icons, Images } from "assets";
import { useAuth } from "context/UseContext";
import i18nInstance from "../../../i18n/i18n";

const LANGUAGES = [
  {
    code: "en",
    label: "English",
    icon: Icons.english,
  },
  {
    code: "ku",
    label: "کوردی",
    icon: Icons.kurdish,
  },
];

const getAssetSrc = (asset) => asset?.default || asset;

function Header() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();

  const [scrollEffect, setScrollEffect] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [langAnchorEl, setLangAnchorEl] = useState(null);  // stores the actual DOM element

  const currentLang =
    LANGUAGES.find((l) => l.code === i18nInstance.language) || LANGUAGES[0];

  const navItems = [
    { title: t("nav.home"),      path: "/" },
    { title: t("nav.services"),  path: "/services" },
    { title: t("nav.aboutUs"),   path: "/about" },
    { title: t("nav.quote"),     path: "/quote" },
    { title: t("nav.careers"),   path: "/careers" },
    { title: t("nav.blogs"),     path: "/blogs" },
    { title: t("nav.contactUs"), path: "/contact" },
  ];

  const handleScroll = () => setScrollEffect(window.scrollY > 1);
  window.addEventListener("scroll", handleScroll);

  const handleDrawerClose = (path) => {
    setOpenDrawer(false);
    setTimeout(() => navigate(path), 1);
  };

  const handleMenuOpen  = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = ()  => setAnchorEl(null);

  // KEY FIX: store the button's DOM node directly into state
  const handleLangOpen  = (e) => setLangAnchorEl(e.currentTarget);
  const handleLangClose = ()  => setLangAnchorEl(null);

  const changeLanguage = (code) => {
    i18nInstance.changeLanguage(code);
    handleLangClose();
  };
  const isKurdish = (i18nInstance.resolvedLanguage || i18nInstance.language || "")
    .toLowerCase()
    .startsWith("ku");
  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        zIndex: 1200,
        height: { xs: "55px", lg: "75px" },
        backgroundColor: Colors.white,
        px: 4,
        boxShadow: scrollEffect ? "0px 2px 10px rgba(0, 0, 0, 0.1)" : "none",
        transition: "all 0.3s ease",
      }}
    >
      {/* ── Desktop ─────────────────────────────────────────────── */}
      <Box sx={{ display: { xs: "none", lg: "flex" }, alignItems: "center", height: "100%" }}>
        <Container maxWidth="100%">
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

            {/* Logo */}
            <Link to="/">
              <Box component="img" src={Images.newLogo} alt="Galaxy World Wide Shipping" height={70} />
            </Link>

            {/* Nav Items */}
            <Box sx={{ display: "flex", gap: 4, justifyContent: "center", flexGrow: 1,
               direction: isKurdish ? "rtl" : "ltr"
                }}>
              {navItems.map((item, index) => (
                <Link key={index} to={item.path}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: Colors.textSecondary,
                      fontFamily: FontFamily.Montserrat,
                      fontWeight: 600,
                      fontSize: isKurdish ? "18px" : undefined,
                      ":hover": { color: Colors.landingPrimary },
                    }}
                  >
                    {item.title}
                  </Typography>
                </Link>
              ))}
            </Box>

            {/* Right: Lang + CTA */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

              {/* Language Button — onClick stores e.currentTarget into state */}
              <Button
                onClick={handleLangOpen}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                  color: Colors.textSecondary,
                  textTransform: "none",
                  fontWeight: 600,
                  fontFamily: FontFamily.Montserrat,
                  border: `1.5px solid ${Colors.textSecondary}`,
                  borderRadius: 2,
                  px: 1.5,
                  py: 0.8,
                  minWidth: 0,
                  ":hover": {
                    borderColor: Colors.landingPrimary,
                    color: Colors.landingPrimary,
                  },
                }}
              >
                <Box
                  component="img"
                  src={getAssetSrc(currentLang.icon)}
                  alt={currentLang.label}
                  sx={{ width: 20, height: 14, objectFit: "cover", borderRadius: "2px" }}
                />
                <Typography variant="body2" sx={{ fontWeight: 600, fontFamily: FontFamily.Montserrat, lineHeight: 1 }}>
                  {currentLang.label}
                </Typography>
                <KeyboardArrowDown sx={{ fontSize: 16 }} />
              </Button>

              {/* Language Menu — anchorEl is the button DOM node set on click */}
              <Menu
                anchorEl={langAnchorEl}
                open={Boolean(langAnchorEl)}
                onClose={handleLangClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                PaperProps={{
                  elevation: 2,
                  sx: {
                    mt: 1,
                    minWidth: 150,
                    borderRadius: 2,
                    boxShadow: "0px 4px 16px rgba(0,0,0,0.12)",
                  },
                }}
              >
                {LANGUAGES.map((lang) => (
                  <MenuItem
                    key={lang.code}
                    selected={lang.code === i18nInstance.language}
                    onClick={() => changeLanguage(lang.code)}
                    sx={{
                      gap: 1.5,
                      fontWeight: lang.code === i18nInstance.language ? 700 : 400,
                      color: lang.code === i18nInstance.language ? Colors.landingPrimary : "inherit",
                    }}
                  >
                    <Box
                      component="img"
                      src={getAssetSrc(lang.icon)}
                      alt={lang.label}
                      sx={{ width: 20, height: 14, objectFit: "cover", borderRadius: "2px" }}
                    />
                    {lang.label}
                  </MenuItem>
                ))}
              </Menu>

              {/* CTA Button */}
              {user?.token ? (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: Colors.landingPrimary,
                    color: Colors.white,
                    fontWeight: 600,
                    borderRadius: 2,
                    py: 1,
                    textTransform: "none",
                    ":hover": { backgroundColor: Colors.primaryDark || Colors.landingPrimary },
                  }}
                  onClick={() => navigate("/dashboard")}
                >
                  {t("header.galaxyBusinessSuite")}
                </Button>
              ) : (
                <Fragment>
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: Colors.landingPrimary,
                      color: Colors.white,
                      fontWeight: 600,
                      borderRadius: 2,
                      py: 1,
                      textTransform: "none",
                      ":hover": { backgroundColor: Colors.primaryDark || Colors.landingPrimary },
                    }}
                    aria-owns={anchorEl ? "simple-menu" : undefined}
                    aria-haspopup="true"
                    onClick={handleMenuOpen}
                    endIcon={<KeyboardArrowRight sx={{ fontSize: { xs: 22, sm: 30 }, color: "#fff" }} />}
                  >
                    {t("header.galaxyBusinessSuite")}
                  </Button>

                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    MenuListProps={{ onMouseLeave: handleMenuClose }}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 14,
                          width: 10,
                          height: 10,
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    }}
                  >
                    <MenuItem onClick={() => navigate("/register")}>
                      {t("header.customerRegistration")}
                    </MenuItem>
                    <MenuItem onClick={() => window.open(`${process.env.REACT_APP_STAFF_BASE_URL}auth`, "_blank", "noopener,noreferrer")}>
                      {t("header.employeeLogin")}
                    </MenuItem>
                    <MenuItem onClick={() => window.open(`${process.env.REACT_APP_CUSTOMER_BASE_URL}`, "_blank", "noopener,noreferrer")}>
                      {t("header.customerLogin")}
                    </MenuItem>
                  </Menu>
                </Fragment>
              )}
            </Box>
          </Box>
        </Container>
      </Box>

      {/* ── Mobile ──────────────────────────────────────────────── */}
      <Box
        sx={{
          display: { xs: "flex", lg: "none" },
          alignItems: "center",
          justifyContent: "space-between",
          height: "100%",
          px: 2,
        }}
      >
        <Link to="/">
          <Box component="img" src={Images.GalaxyLogo} alt="Galaxy World Wide Shipping" height={60} width={250} />
        </Link>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            onClick={handleLangOpen}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.8,
              color: Colors.textSecondary,
              textTransform: "none",
              fontWeight: 600,
              border: `1.5px solid ${Colors.textSecondary}`,
              borderRadius: 2,
              px: 1.5,
              py: 0.8,
              minWidth: 0,
              ":hover": { borderColor: Colors.landingPrimary, color: Colors.landingPrimary },
            }}
          >
            <Box
              component="img"
              src={getAssetSrc(currentLang.icon)}
              alt={currentLang.label}
              sx={{ width: 20, height: 14, objectFit: "cover", borderRadius: "2px" }}
            />
            <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1 }}>
              {currentLang.label}
            </Typography>
            <KeyboardArrowDown sx={{ fontSize: 16 }} />
          </Button>

          <Button onClick={() => setOpenDrawer(true)}>
            <MenuIcon />
          </Button>
        </Box>

        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          PaperProps={{ style: { width: "100%" } }}
        >
          <List>
            <ListItem sx={{ justifyContent: "flex-end" }}>
              <ListItemButton onClick={() => setOpenDrawer(false)}>
                <CloseIcon />
              </ListItemButton>
            </ListItem>
            <ListItem sx={{ justifyContent: "center" }}>
              <Box component="img" src={Images.logo} alt="Logo" height={100} />
            </ListItem>
            {navItems.map((item, index) => (
              <ListItem key={index}>
                <ListItemButton onClick={() => handleDrawerClose(item.path)}>
                  <ListItemText
                    primary={item.title}
                    primaryTypographyProps={{
                      fontSize: isKurdish ? "1.2rem" : undefined,
                      fontWeight: isKurdish ? 600 : undefined,
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </Box>
    </Box>
  );
}

export default Header;